import { useCallback } from 'react';
import { useCartStore } from '@/service/state/Cart/useCartStore';
import { useCountdown } from '@/service/hooks/useCountdown';
import { FormButton } from '@/ui/common/Buttons/FormButton';
import { CloseWhiteIcon } from '@/ui/common/Icons/CloseWhiteIcon';

export const TicketExpirationInfo = ({ partnerSlug }: { partnerSlug: string }) => {
    const { cart, extCart } = useCartStore();

    const { countdown, hours, minutes, seconds } = useCountdown(
        cart?.time_left && cart.time_left > 0 ? cart.time_left : 0
    );

    const extendTimeByFiveMinutes = useCallback(
        () => extCart({ partnerId: partnerSlug }),
        [extCart, partnerSlug]
    );

    if (countdown <= 0) return null;

    return (
        <>
            <div
                data-test-id="cart-timer"
                className="mb-4 flex h-6 w-full max-w-[384px] items-center justify-center space-x-1 px-4 sm:mb-10 md:px-8"
            >
                <span className="tx-large-medium w-56 text-end text-gray-3 dark:text-dark-1">
                    Tickets are being held for:
                </span>
                <span className="tx-large-medium w-20 text-state-error">{`${hours}:${minutes}:${seconds}`}</span>
            </div>
            {+minutes < 1 && (
                <FormButton
                    type="button"
                    className="mx-0 mb-2 h-9 max-w-[270px] p-0"
                    label={
                        <div className="flex w-full items-center">
                            <CloseWhiteIcon width={32} height={32} className="ml-2" />
                            Extend time by 2 minutes
                        </div>
                    }
                    onClick={extendTimeByFiveMinutes}
                    data-test-id="extend-by-5-mins-btn"
                />
            )}
        </>
    );
};
